import Controller from '@ember/controller';
import { computed, get, set, setProperties } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  contactsCache: service(),
  store: service(),
  uploadContacts: service(),

  error: null,
  savingContactIndex: -1,

  hasMoreContactsToSave: computed(
    'savingContactIndex',
    'uploadContacts.contactObjects.length',
    function () {
      return (
        this.savingContactIndex <
        get(this, 'uploadContacts.contactObjects.length')
      );
    },
  ),

  contactsToSave: alias('uploadContacts.contactObjects.length'),
  savingContactNumber: computed('savingContactIndex', function () {
    return this.savingContactIndex + 1;
  }),

  reset() {
    setProperties(this, {
      error: null,
      savingContactIndex: -1,
    });
  },

  save: task(function* () {
    try {
      this.incrementProperty('savingContactIndex');
      if (!this.hasMoreContactsToSave) {
        return;
      }
      let contactObject =
        this.uploadContacts.contactObjects[this.savingContactIndex];
      let record = this.store.createRecord('contact', contactObject);
      yield record.save();
      this.contactsCache.addContact(record);
      this.save.perform();
    } catch (error) {
      set(this, 'error', error);
    }
  }),
});
